/**
 * Every `component.type` this app knows about, mapped to the Linear ticket that owns it.
 *
 * Deliberately a **pure data module**: no imports, no React, no `@/` alias. That is what
 * lets `scripts/check-configs.ts` import it under plain Node (via tsx) and fail the config
 * check when a deployed config carries a `type` nobody implements — a mistake that otherwise
 * shows up as an empty box on a wall with one line in a console nobody is reading.
 *
 * The list is the `components` block of legacy `moduleLoader.vue`, which registered fourteen
 * widgets. (`utils/functions.ts`'s `getWidgets()` returned a shorter list; it was dead code
 * by the end and is not a source of truth.) Cross-checked against the `type` values present
 * across the seven deployed configs, which use eleven of the fourteen —
 * `ProgressBar`, `TravelWidget` and `GroupWidget` appear in none of them but are kept,
 * because the legacy app registered them and a config can start using one without a code
 * change.
 *
 * | Type                   | Configs using it | Ticket  |
 * | ---------------------- | ---------------- | ------- |
 * | `GroupWidget`          | 0                | SYM-491 |
 * | `Logo`                 | 4                | SYM-495 |
 * | `TextWidget`           | 4                | SYM-495 |
 * | `DateWidget`           | 7                | SYM-495 |
 * | `ImageLabelWidget`     | 7                | SYM-495 |
 * | `ProgressBar`          | 0                | SYM-495 |
 * | `DoughnutWidget`       | 4                | SYM-496 |
 * | `HourlyChartWidget`    | 4                | SYM-496 |
 * | `FloorOccupancyWidget` | 3                | SYM-496 |
 * | `TopSpacesWidget`      | 4                | SYM-496 |
 * | `WeatherWidget`        | 3                | SYM-501 |
 * | `DepartureWidget`      | 3                | SYM-501 |
 * | `BookingsWidget`       | 3                | SYM-501 |
 * | `TravelWidget`         | 0                | SYM-501 |
 *
 * Adding a widget type means adding it here *and* to `widgetRegistry`. Anything here that is
 * not in the registry renders `PlaceholderWidget` labelled with its ticket, so this table is
 * also the migration's remaining-work list.
 */
export const widgetTypeOwners: Record<string, string> = {
  GroupWidget: 'SYM-491',
  Logo: 'SYM-495',
  TextWidget: 'SYM-495',
  DateWidget: 'SYM-495',
  ImageLabelWidget: 'SYM-495',
  ProgressBar: 'SYM-495',
  DoughnutWidget: 'SYM-496',
  HourlyChartWidget: 'SYM-496',
  FloorOccupancyWidget: 'SYM-496',
  TopSpacesWidget: 'SYM-496',
  WeatherWidget: 'SYM-501',
  DepartureWidget: 'SYM-501',
  BookingsWidget: 'SYM-501',
  TravelWidget: 'SYM-501',
};
